import { customAlphabet } from "nanoid";
function is_safari() {
  let chrome_agent = navigator.userAgent.indexOf("Chrome") > -1;
  let safari_agent = navigator.userAgent.indexOf("Safari") > -1;
  if (chrome_agent && safari_agent)
    safari_agent = false;
  return safari_agent;
}
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const _nanoid = customAlphabet(
  "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
  21
);
function nanoid() {
  return _nanoid();
}
function formatDate(dateString, withTime) {
  const date = new Date(dateString);
  if (withTime) {
    if (date.toDateString() === (/* @__PURE__ */ new Date()).toDateString()) {
      return date.toLocaleString("en-US", { hour: "numeric", minute: "numeric", hour12: true });
    } else {
      const opts = {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true
      };
      if (date.getFullYear() !== (/* @__PURE__ */ new Date()).getFullYear()) {
        opts.year = "numeric";
      }
      return date.toLocaleDateString("en-US", opts);
    }
  } else {
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric"
    });
  }
}
function toDateString(value) {
  const date = value ? new Date(value) : /* @__PURE__ */ new Date();
  return date.toLocaleDateString("en-GB").split("/").reverse().join("-");
}
function addLeadingZero(num) {
  num = num.toString();
  while (num.length < 2)
    num = "0" + num;
  return num;
}
function buildRFC822Date(dateString) {
  const dayStrings = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const monthStrings = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  const timeStamp = Date.parse(dateString);
  const date = new Date(timeStamp);
  const day = dayStrings[date.getDay()];
  const dayNumber = addLeadingZero(date.getDate());
  const month = monthStrings[date.getMonth()];
  const year = date.getFullYear();
  return `${day}, ${dayNumber} ${month} ${year} 00:00:00 +0000`;
}
function encodeHTMLEntities(rawStr) {
  return rawStr.replace(/[\u00A0-\u9999<>&]/g, (i) => "&#" + i.charCodeAt(0) + ";");
}
function isEmailValid(email) {
  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(email);
}
export {
  is_safari as a,
  buildRFC822Date as b,
  classNames as c,
  encodeHTMLEntities as e,
  formatDate as f,
  isEmailValid as i,
  nanoid as n,
  toDateString as t
};
